import { render, staticRenderFns } from "./EditPicture.vue?vue&type=template&id=6348eb62&"
import script from "./EditPicture.vue?vue&type=script&lang=js&"
export * from "./EditPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports